<template>
  <div class="d-flex align-items-center justify-content-between">
    <div class="mr-2">
      <label class="input-group">
        <span class="input-group-prepend"><span class="input-group-text">От</span></span>
        <datepicker v-model="input.min" :placeholder="range.min"></datepicker>
      </label>
    </div>
    <div>
      <label class="input-group">
        <span class="input-group-prepend"><span class="input-group-text">До</span></span>
        <datepicker v-model="input.max" :placeholder="range.max"></datepicker>
      </label>
    </div>
  </div>
</template>

<script>
  import { pickBy } from 'lodash'
  import FilterRange from './filter-range.vue'

  export default {
    name: 'FilterRangeDate',
    extends: FilterRange,
    computed: {
      preparedInput () {
        return pickBy(this.input)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-range-date.vue